(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5801],{

/***/ 977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up",
      function () {
        return __webpack_require__(28480);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23474);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Menu_Auth_RegisterModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37190);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75943);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ReferralSignUp = function() {
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Menu_Auth_RegisterModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            dataReferralCode: router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.referral_code) === null || ref1 === void 0 ? void 0 : ref1.toString()
        })
    });
};
ReferralSignUp.chains = [
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.BSC */ .a_.BSC,
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.BSC_TESTNET */ .a_.BSC_TESTNET,
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.ONUS */ .a_.ONUS,
    _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_2__/* .ChainId.ONUS_TESTNET */ .a_.ONUS_TESTNET
];
/* harmony default export */ __webpack_exports__["default"] = (ReferralSignUp);
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4222440c-0"
})(_templateObject());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(977); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);